import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ValidationMessageComponent } from '../../../../shared/components/validation-message/validation-message.component';
import { CaptchaComponent } from '../../../../shared/components/captcha/captcha.component';
import { MiddlewareService } from '../../../../core/services/middleware.service';
import { EncryptionService } from '../../../../core/services/encryption.service';
import { CommonService } from '../../../../core/services/common.service';
import { ApiResponse } from '../../../../core/enums/api-response.enum';
import { apiURL } from '../../../../../assets/data/api-url';
import { globalDatas } from '../../../../../assets/data/globals';
import { BusinessIdDirective } from '../../../../shared/directives/business-id.directive';
import { ModalType } from '../../../../core/enums/modal-type.enum';
import { ModalService } from '../../../../core/services/modal.service';
import { preferredLanguage } from '../../../../core/enums/preferred-language.enum';
import { ProfileType } from '../../../../core/enums/visa-types.enum';
import { RouteType } from '../../../../core/enums/route-type.enum';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MobileAuthInstructionComponent } from '../../../../shared/components/mobile-auth-instruction/mobile-auth-instruction.component';
import { mobileIdPathEnum } from '../../../../core/enums/mobileId-path.enum';
import { IdNotRegisterdInfoComponent } from '../../../user/profile/add-edit-profile-details/id-not-registerd-info/id-not-registerd-info.component';

@Component({
  selector: 'app-government-sign-in',
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    ValidationMessageComponent,
    TranslateModule,
    CaptchaComponent,
    BusinessIdDirective
  ],
  templateUrl: './government-sign-in.component.html',
  styleUrl: './government-sign-in.component.scss'
})
export class GovernmentSignInComponent {
  governmentSignInForm!: FormGroup;
  isSubmitted = false;
  showPassword = false;
  showCaptcha = false;
  private formSubscription: Subscription | null = null;
  businessIdMaxLength = globalDatas.BUSINESS_ID_MAX_LIMIT;
  businessIdMinLength = globalDatas.BUSINESS_ID_MIN_LIMIT;
  mobileIdPathEnum = mobileIdPathEnum;

  constructor(
    public router: Router,
    private _fb: FormBuilder,
    private _middlewareService: MiddlewareService,
    private encryptionService: EncryptionService,
    private commonService: CommonService,
    protected translateService: TranslateService,
    private commonModalService: ModalService,
    private ngbModalService: NgbModal
  ) {
    this.loadgovernmentSignInForm();
  }

  ngOnInit(): void {
    this.formSubscription = this.governmentSignInForm.valueChanges.subscribe((value) => {
      if (this.isSubmitted) {
        this.showCaptcha = false;
      }
    });
  }

  ngOnDestroy(): void {
    this.formSubscription?.unsubscribe();
  }

  loadgovernmentSignInForm() {
    this.governmentSignInForm = this._fb.group({
      commercialLoginId: [
        '',
        [
          Validators.required,
          Validators.maxLength(globalDatas.BUSINESS_ID_MAX_LIMIT),
          Validators.minLength(globalDatas.BUSINESS_ID_MIN_LIMIT),
        ],
      ]
    });
  }

  onClickSignIn() {
    this.isSubmitted = true;
    if (this.governmentSignInForm.valid) {
      this.showCaptcha = true;
      // this.onSubmit();
    }
  }

  onSubmit() {
    if (this.governmentSignInForm.valid) {
      this.governmentSignInForm.get('commercialLoginId')?.setValue(this.governmentSignInForm.get('commercialLoginId')?.value?.toLowerCase());
      const encryptedPayload = this.encryptionService.encryptData(
        this.governmentSignInForm.value
      );
      this._middlewareService
        .callPostMiddleware(apiURL.mobileIdAuthInitGov, { payload: encryptedPayload })
        .subscribe({
          next: (response: any) => {
            if (response?.code === ApiResponse.OK) {
              if (response?.result?.notification && response?.result?.civilId) {
                const notificationObj = JSON.parse(response?.result?.notification);
                if (notificationObj.error) {
                  this.commonModalService.commonAlertModal(notificationObj?.data, ModalType.FAIL);
                  return;
                } else {
                  const modalRef = this.ngbModalService.open(MobileAuthInstructionComponent, {
                    centered: true,
                    size: 'lg',
                    backdrop: 'static',
                  });
                  modalRef.componentInstance.mobileAuthTrackId = notificationObj?.data;
                  modalRef.componentInstance.mobileIdPath = mobileIdPathEnum.GOVERNMENT_AUTH;
                  modalRef.componentInstance.loginId = this.governmentSignInForm.get('commercialLoginId')?.value;
                  modalRef.result.then(
                    (result) => {
                      if (result && result.message === 'success') {
                        result?.response?.commercialLoginId ?
                          this.handleSuccessResponse(result?.response) :
                          this.commonModalService.commonAlertModal("BUSINESS_SIGN_IN.NO_ACCOUNT_ERROR_MESSAGE", ModalType.FAIL);
                      } else if (result === 'User is not eligible') {
                        this.ngbModalService.open(IdNotRegisterdInfoComponent, {
                          centered: true,
                          size: 'xl',
                          backdrop: 'static',
                        });
                      }
                    });
                }
              } else {
                this.commonModalService.commonAlertModal("BUSINESS_SIGN_IN.NO_ACCOUNT_ERROR_MESSAGE", ModalType.FAIL);
              }
            }
          },
          error: (error: any) => {
            this.commonModalService.commonAlertModal("BUSINESS_SIGN_IN.NO_ACCOUNT_ERROR_MESSAGE", ModalType.FAIL);
            //  this.commonModalService.commonAlertModal("ERROR_MESSAGES.DEFUALT_ERROR", ModalType.WARNING);
          },
        });
    }
  }

  handleSuccessResponse(response: any) {
    if (response?.companyRefs?.length) {
      response?.companyRefs?.forEach((item: any) => {
        item.organizationNumber = item.organizationNumber?.trim();
        if (item?.organizationName) {
          item.organizationName = item.organizationName?.trim();
        }
      })
    }
    localStorage.setItem(
      'xyzACCjsiiyu',
      this.commonService.generateRandomString(20)
    );
    localStorage.setItem('accty', this.commonService.generateRandomString(10) + ProfileType.Government + this.commonService.generateRandomString(10));
    localStorage.getItem('preferredLanguage') ?
      this.commonService.setLanguage(localStorage.getItem('preferredLanguage')) :
      this.commonService.setLanguage(this.translateService.currentLang === 'ar' ? preferredLanguage.ARABIC : preferredLanguage.ENGLISH);
    this.commonService.setAuthenticatedSignal(true);
    // Instana user tracking
    const ineum = (window as any).ineum;
    if (typeof ineum === 'function') {
      ineum('meta', 'governmentUserEmail', response?.email);
      ineum('meta', 'governmentLoginId', response?.commercialLoginId);
    }
    // setTimeout(() => {
    //   window.location.reload();
    // }, 5000);
    this.router.url.includes(RouteType.GOVERNMENT_PAYMENT_SIGN_IN) ?
      this.router.navigate([this.commonService.getRouteStartIndex() + RouteType.GOVERNMENT_APPLICATION]) :
      this.router.navigate([this.commonService.getRouteStartIndex() + RouteType.GOVERNMENT_PROFILE], { state: { govDetails: response } });
  }

  handleRecaptchaResponse(response: boolean) {
    if (response) {
      this.onSubmit();
    }
  }

}
